import chexfinerfoodsLogo from "/img/integration/chexfinerfoods.png"
import { ConnectEmailPage } from "@/setup/connect/connect-email-page"
import { EmailConfigPage } from "@/setup/config/email-config-page"
import { BackToSettingsButton } from "@/setup/connect/settings-connect-layout"

export function SettingsConnectChexFinerFoodsPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectEmailPage
        logo={chexfinerfoodsLogo}
        logoAlt="Chex Finer Foods"
        integrationName="chexfinerfoods"
        description="Chex Finer Foods sends deduction and dispute information via email. Connect the email account(s) that receive Chex Finer Foods communications."
        redirectTo="/settings/config/chexfinerfoods"
      />
    </div>
  )
}

export function SettingsConfigChexFinerFoodsPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <EmailConfigPage
        logo={chexfinerfoodsLogo}
        logoAlt="Chex Finer Foods"
        integrationName="chexfinerfoods"
        displayName="Chex Finer Foods"
        connectPath="/settings/connect/chexfinerfoods"
      />
    </div>
  )
}
